const state = {
  pwaCanBeInstalled: false,

  pwaInstallPrompt: undefined,

  pwaInstalled: false,
};

const mutations = {
  pwaCanBeInstalledMutation: (state, payload) => {
    state.pwaCanBeInstalled = payload;
  },

  pwaInstallPromptMutation: (state, payload) => {
    state.pwaInstallPrompt = payload;
  },

  pwaInstalledMutation: (state, payload) => {
    state.pwaInstalled = payload;
  },
};

const actions = {
  pwaCanBeInstalledAction: ({ commit }, payload) => {
    commit("pwaCanBeInstalledMutation", payload);
  },

  pwaInstallPromptAction: ({ commit }, payload) => {
    commit("pwaInstallPromptMutation", payload);
  },

  pwaInstalledAction: ({ commit }, payload) => {
    commit("pwaInstalledMutation", payload);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
